import executeQuery from "#lib/db"

export const getQuantities = async () => {
	const list = await executeQuery({
		query: "select * from quantities",
	})

	return list
}
